import { validator } from '@ally/validator';
import { BANK_PHONE_NUMBER, INTERNAL_LIMIT } from '../../../constants';
var DoesNotExceedInternalLimit = function (amount) {
    return amount <= INTERNAL_LIMIT;
};
export var DoesNotExceedInternalLimitErrorMessage = "Enter an amount less than or equal to ".concat(INTERNAL_LIMIT, ". Call us 24/7 at ").concat(BANK_PHONE_NUMBER, " for help.");
export var DoesNotExceedInternalLimitValidator = validator(DoesNotExceedInternalLimit, DoesNotExceedInternalLimitErrorMessage);
//# sourceMappingURL=DoesNotExceedInternalLimit.js.map